import React, { useState, useEffect, useRef, useCallback  } from "react";
import "../css/Style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faFloppyDisk,
  faGear,
  faTrash,
  faPenToSquare,
  faClockRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import api from "../services/api";
import {
  handleAddUser,
  handleUpdateUser,
  handleLineNumber,
  handleDeleteUser,
  handleRecoverMaker,
  handleTsdLogs,
} from "../services/api";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { debounce } from "lodash";
import withReactContent from 'sweetalert2-react-content';

const TsdSettings = () => {
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [lineNumberList, setLineNumber] = useState([]);
  const [companySuggestions, setCompanySuggestions] = useState({});
  const suggestionRef = useRef(null);
  const [filterType, setFilterType] = useState("S");
  const [tempEdits, setTempEdits] = useState({});
  const [allUsers, setAllUsers] = useState([]);
  const [displayedUsers, setDisplayedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [companyData, setCompanyData] = useState([]);

  const debouncedSetSearchQuery = useCallback(debounce((val) => {
    setSearchQuery(val.toLowerCase());
  }, 300), []);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await fetchTsdSettings(filterType, false, 1, searchQuery);
      await updateLineNumberList(filterType);
      await updateCompanyList(filterType);
      setLoading(false);
    };

    loadData();
  }, [filterType, searchQuery]);
  useEffect(() => {
  const handleBeforeUnload = (e) => {
    if (Object.keys(tempEdits).length > 0) {
      e.preventDefault();
      e.returnValue = ""; // Required for Chrome
    }
  };

  window.addEventListener("beforeunload", handleBeforeUnload);

  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, [tempEdits]);

  const [pagination, setPagination] = useState({
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
  });
const formatDate = (dateStr) => {
  const date = new Date(dateStr);
    if (isNaN(date)) return "-";

    const options = {
      year: "numeric",
      month: "long",   
      day: "2-digit", 
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Manila"
    };

    const formatted = date.toLocaleString("en-PH", options);

    return formatted
      .replace(", ", ",")
      .replace("AM", "am")
      .replace("PM", "pm");
  };


  const fetchTsdSettings = async (
    type = "S",
    setLineNumbersOnly = false,
    page = 1,
    search = ""
  ) => {
    try {
      const response = await api.post(`get_tsd_settings`,{
        per_page: pagination.per_page,
        page: page,
        type,
        search,
      });

      const hasUnsavedChanges = Object.keys(tempEdits).length > 0;


      const result = response.data.result;
      const pag = response.data.pagination;

      const uniqueLineNumbers = lineNumberList.map(String);

      const formattedUsers = result.map((user) => ({
        id: user.task_pattern_sample_maker_id.toString(),
        name: user.name.trim(),
        type: user.type,
        company: user.company,
        lineLeader: user.is_line_leader === "Y",
        assistant: user.is_asst === "Y",
        lineNumber: user.line_number.toString(),
      }));

      if (setLineNumbersOnly) {
        setLineNumber(uniqueLineNumbers);
        return;
      }

      setUsers(formattedUsers);
      setAllUsers(formattedUsers);
      setDisplayedUsers(formattedUsers);
      if (pag) setPagination(pag); // <- Save pagination info
    } catch (error) {
      console.error("Error fetching TSD settings:", error);
    }
  };

  const addNewUserLocal = () => {
    const newUser = {
      id: "",
      name: "New User",
      company: "",
      lineLeader: false,
      assistant: false,
      lineNumber: "",
      type: filterType,
    };

    setUsers((prev) => [newUser, ...prev]);
    setAllUsers((prev) => [newUser, ...prev]);
    setDisplayedUsers((prev) => [newUser, ...prev]);
  };

  const handleToggleExclusive = (index, field) => {
    // IF lineleader- line assistant isa lang pede
    setUsers((prevUsers) => {
      const updated = [...prevUsers];
      if (field === "lineLeader") {
        updated[index].lineLeader = !updated[index].lineLeader;
        if (updated[index].lineLeader) updated[index].assistant = false;
      } else if (field === "lineAssistant") {
        updated[index].assistant = !updated[index].assistant;
        if (updated[index].assistant) updated[index].lineLeader = false;
      }
      return updated;
    });
  };

  const handleInputChange = (index, field, value) => {
     const userToSave = users[index]; //for unsaved edits


    setUsers((prevUsers) => {
      const updated = [...prevUsers];
      updated[index] = { ...updated[index], [field]: value };

      if (field === "type") {
        updated[index].lineNumber = "";
        updateLineNumberList(value);
      }

      return updated;
    });

    setTempEdits((prev) => ({
      ...prev,
      [index]: {
        ...(prev[index] || {}),
        [field]: true,

      },
    }));


    if (field === "company") {
      const filtered = companies.filter((c) =>
        c.toLowerCase().startsWith(value.toLowerCase())
      );
      setCompanySuggestions((prev) => ({
        ...prev,
        [index]: filtered,
      }));
    }
  };
  const updateLineNumberList = async (type) => {
    try {
      const response = await api.post(`tsd_other_settings`,{
        type: type === "S" ? "sample_line_number" : "pattern_line_number",
        action: "view",
      });

      const result = response.data.result || [];
      const lineNumbers = result
        .sort((a, b) => a - b)
        .map((line) => line.toString());

      setLineNumber(lineNumbers);
    } catch (error) {
      console.error("Error fetching line numbers:", error);
    }
  };

  // const handleSelectCompanySuggestion = (index, company) => {
  //   setUsers((prevUsers) => {
  //     const updated = [...prevUsers];
  //     updated[index].company = company;
  //     return updated;
  //   });
  //   setCompanySuggestions((prev) => ({
  //     ...prev,
  //     [index]: []
  //   }));
  // };
  const updateCompanyList = async (type) => {
    try {
      const response = await api.post(`tsd_other_settings`,{
          type: "company",
          filterType: type,
          action: "view",
        });

      const result = response.data.result || [];

      // Store both key and value
      const structured = result.map((val, index) => ({
        key: index,
        value: val.trim(),
      }));

      setCompanyData(structured);
      setCompanies(structured.map((c) => c.value)); // for dropdown
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const handleCompany = async () => {
    if (!filterType) {
      Swal.fire("Please select a type first.", "", "warning");
      return;
    }

    await updateCompanyList(filterType);

    if (!companies.length) {
      const { value: addNew } = await Swal.fire({
        title: "No companies found",
        text: "Would you like to add one?",
        input: "text",
        inputPlaceholder: "Enter new company",
        inputValidator: (val) => {
          if (!val.trim()) return "Please enter a valid name.";
        },
        showCancelButton: true,
        confirmButtonText: "Add",
      });

      if (addNew) {
        return saveCompanyChange("add", addNew);
      }
      return;
    }

    const container = document.createElement("div");
    container.innerHTML = `
    <div class="mb-3" style="max-height: 300px; overflow-y: auto;">
      ${companies
        .map(
          (c, i) => `
          <div class="d-flex justify-content-between align-items-center border rounded px-2 py-1 mb-1">
            <div>${c}</div>
            <div>
              <button class="btn btn-sm btn-primary me-1" data-edit="${i}">Edit</button>
              <button class="btn btn-sm btn-danger" data-delete="${i}">Delete</button>
            </div>
          </div>
        `
        )
        .join("")}
    </div>
    <div class="text-center mt-3">
      <button id="add-company-btn" class="btn btn-success btn-sm">➕ Add Company</button>
    </div>
  `;

    await Swal.fire({
      title: `Edit Companies (${filterType})`,
      html: container,
      showConfirmButton: false,
      showCloseButton: true,
      didOpen: () => {
        const companiesWithKey = companies.map((val, idx) => ({
          key: idx,
          value: val,
        }));

        container.querySelectorAll("[data-edit]").forEach((btn) => {
          btn.addEventListener("click", async () => {
            const index = parseInt(btn.getAttribute("data-edit"));
            const item = companiesWithKey[index];

            const { value: newName } = await Swal.fire({
              title: "Edit Company",
              input: "text",
              inputValue: item.value,
              inputValidator: (val) => {
                if (!val.trim()) return "Cannot be empty";
              },
              showCancelButton: true,
              confirmButtonText: "Save",
            });

            if (newName && newName !== item.value) {
              await saveCompanyChange("edit", newName, null, item.key);
              Swal.close();
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Company added",
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
              });
              setTimeout(() => window.location.reload(), 1500);
            }
          });
        });

        container.querySelectorAll("[data-delete]").forEach((btn) => {
          btn.addEventListener("click", async () => {
            const index = parseInt(btn.getAttribute("data-delete"));
            const item = companiesWithKey[index];

            const confirm = await Swal.fire({
              title: "Delete Company?",
              text: `Are you sure you want to delete "${item.value}"?`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it",
            });

            if (confirm.isConfirmed) {
              await saveCompanyChange("delete", null, null, item.key);
              Swal.close();
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Company updated. Reloading...",
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
              });
              setTimeout(() => window.location.reload(), 1500);
            }
          });
        });

        //  ADD COMPANY
        const addBtn = container.querySelector("#add-company-btn");
        if (addBtn) {
          addBtn.addEventListener("click", async () => {
            const { value: newName } = await Swal.fire({
              title: "Add New Company",
              input: "text",
              inputPlaceholder: "Enter company name",
              inputValidator: (val) => {
                if (!val.trim()) return "Cannot be empty";
              },
              showCancelButton: true,
              confirmButtonText: "Add",
            });

            if (newName) {
              await saveCompanyChange("add", newName);
              Swal.close();
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Company added",
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
              });
              setTimeout(() => window.location.reload(), 1500);
            }
          });
        }
      },
    });
  };


  const saveCompanyChange = async (
    action,
    value = null,
    oldValue = null,
    key = null
  ) => {
    try {
      let payload = [];

      if (action === "edit") {
        payload = [{ key, value }];
      } else if (action === "delete") {
        payload = [{ key }];
      } else if (action === "add") {
        payload = [{ value }];
      }

      await api.post(`tsd_other_settings`,{
          type: "company",
          filterType,
          action,
          payload,
        });
    } catch (error) {
      console.error(`Error during ${action}:`, error);
    }
  };

  const handleSaveUser = async (user) => {
    try {
      const payload = {
        id: user.id,
        name: user.name.trim(),
        is_line_leader: user.lineLeader ? "Y" : "N",
        type: user.type,
        is_asst: user.assistant ? "Y" : "N",
        line_number: user.lineNumber.toString().trim(),
        company: user.company.trim(),
      };

      if (user.id) {
        console.log("Updating user:", payload);
        await handleUpdateUser(payload);
      } else {
        console.log("Creating user:", payload);
        await handleAddUser(payload);
      }

      await fetchTsdSettings(filterType, false, 1, searchQuery);

        const index = users.findIndex((u) => u.id === user.id || u === user);
          setTempEdits((prev) => {
            const updated = { ...prev };
           delete updated[index];
            return updated;
          });
      Swal.fire({ 
        icon: "success",
        title: "Saved!",
        text: "",
        timer: 1500,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error("Error saving user:", error);
      if (error.response?.data) {
        console.error("Backend response:", error.response.data);
        alert(JSON.stringify(error.response.data.errors, null, 2));
      }
    }
  };

  const handleDeleteUser = async (id) => {
    if (!id) return;

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will mark the user as deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
    });

    if (!confirm.isConfirmed) return;

    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const payload = {
        id,
        is_recover: 0,
      };
      await axios.put(`${process.env.REACT_APP_API_URL}/delete_recover_maker`, payload, config);


      Swal.fire({
        icon: "success",
        title: "Deleted!",
        timer: 1500,
        showConfirmButton: false,
      });

      await fetchTsdSettings(filterType, false, pagination.current_page);
    } catch (error) {
      console.error("Delete error:", error);
      Swal.fire("Failed", "Could not delete user", "error");
    }
  };
  const handleRecoverMaker = async (id) => {
    if (!id) return;

    const confirm = await Swal.fire({
      title: "Recover maker?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });

    if (!confirm.isConfirmed) return;

    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const payload = {
        id,
        is_recover: 1,
      };
      await axios.put(`${process.env.REACT_APP_API_URL}/delete_recover_maker`, payload, config);


      Swal.fire({
        icon: "success",
        title: "Recovered!",
        timer: 1500,
        showConfirmButton: false,
      });

      await fetchTsdSettings(filterType, false, pagination.current_page);
    } catch (error) {
      console.error("Delete error:", error);
      Swal.fire("Failed", "Could not recover user", "error");
    }
  };
  const handleLineNumber = async () => {
    const { value: action } = await Swal.fire({
      title: "Line Number Action",
      text: `You currently have ${lineNumberList.length} line number(s).\nDo you want to add or delete line numbers?`,
      icon: "question",
      input: "radio",
      inputOptions: {
        add: "Add",
        minus: "Delete",
      },
      inputValidator: (value) => {
        if (!value) return "You need to choose one!";
      },
      showCancelButton: true,
      confirmButtonText: "Next",
    });

    if (!action) return;

    const { value } = await Swal.fire({
      title: action === "add" ? "How many to add?" : "How many to delete?",
      input: "number",
      inputAttributes: {
        min: 1,
      },
      inputValidator: (val) => {
        if (!val || isNaN(val) || val <= 0) {
          return "Please enter a valid number greater than 0.";
        }
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
    });

    if (!value) return;

    try {
      const payload = {
        type: filterType === "S" ? "sample_line_number" : "pattern_line_number",
        action: "edit",
        payload: [
          {
            action, // either "add" or "minus"
            value: value.toString(),
          },
        ],
      };

      const response = await api.post(`tsd_other_settings`,
        payload
      );

      if (response.data.result) {
        Swal.fire({
          icon: "success",
          title: "Line number updated!",
          timer: 1500,
          showConfirmButton: false,
        });

        // Update line numbers only
        await fetchTsdSettings(filterType, true);
        await updateLineNumberList(filterType);
        setUsers((prev) => [...prev]);
      } else {
        Swal.fire({
          icon: "error",
          title: "No result received",
          text: response.data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: error?.response?.data?.message || error.message,
      });
    }
  };

  const getTypeClass = (type) => {
    switch (type) {
      case "delete":
        return "text-danger"; // red
      case "recover":
        return "text-success"; // green
      case "add":
        return "text-primary"; // blue
      case "update":
        return "text-warning"; // orange
      default:
        return "";
    }
  };



  const handleTsdLogs = async () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    let allLogs = [];
    let pagination = {};

    const fetchLogs = async (filters = {}) => {
      try {
        const response = await api.post(`tsd_settings_logs`, {
          page: filters.page || 1,
          per_page: filters.per_page || 10,
          search: filters.search || '',
          user_id: filters.user_id,
          excludes: filters.excludes,
          task_pattern_sample_maker_id: filters.task_pattern_sample_maker_id,
        });

        allLogs = response.data.result || [];
        pagination = response.data.pagination || {};
      } catch (error) {
        console.error("Failed to fetch logs", error);
        Swal.fire("Error", "Unable to fetch logs", "error");
      }
    };

    const renderTable = (logs) => {
      if (!logs.length) {
        return `<div class="text-muted text-center">No logs found</div>`;
      }

      return `
        <div style="max-height: 300px; overflow-y: auto;">
          <table class="table table-bordered table-sm table-striped">
            <thead class="table-light">
              <tr>
                <th>Date</th>
                <th style="width:10%;">Name</th>
                <th>Description</th>
                <th>Changed by</th>
                <th style="width:8%;">Action</th>
              </tr>
            </thead>
            <tbody>
              ${logs
                .filter(log => log.logs_description?.toLowerCase() !== "no changes made")
                .map(log => {
                  const recoverBtn = log.logs_type === "delete"
                    ? `<button class="btn btn-sm btn-success recover-btn" data-maker-id="${log.task_pattern_sample_maker_id}"> Recover</button>` 
                    : "";
                  return `
                    <tr>
                      <td>${formatDate(log.logs_date)}</td>
                      <td>${log.maker_name || "-"}</td>
                      <td class="${getTypeClass(log.logs_type)}">${log.logs_description || "-"}</td>
                      <td>${log.logs_by_name || "-"}</td>
                      <td>${recoverBtn}</td>
                    </tr>
                  `;
                }).join("")}
            </tbody>
          </table>
        </div>
      `;
    };

    await fetchLogs();

    await Swal.fire({
      title: "TSD Logs",
      html: `
        <div class="card mb-4 p-3">
          <div class="row align-items-center mb-3">
            <div class="col-md-8">
              <label class="form-label fw-semibold w-100 text-start">Exclude Log Types:</label>
              <div class="d-flex flex-wrap gap-2">
                ${["add", "update", "delete", "recover"]
                  .map(type => `
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" value="${type}" id="excl-${type}">
                      <label class="form-check-label" for="excl-${type}">
                        ${type[0].toUpperCase() + type.slice(1)}
                      </label>
                    </div>
                  `).join("")}
              </div>
            </div>

            <div class="col-md-4 mt-3 mt-md-0">
              <label for="search-logs" class="form-label fw-semibold">Search Logs:</label>
              <div class="input-group">
                <input type="text" id="search-logs" class="form-control" placeholder="Enter keyword...">
                <button type="button" class="btn btn-primary" id="apply-filter">Filter</button>
              </div>
            </div>
          </div>
        </div>
        <div id="log-table">${renderTable(allLogs)}</div>
        <div class="text-end mt-3" id="pagination-controls"></div>
      `,
      width: '90%',
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        title: "swal-title",
        htmlContainer: "swal-text",
      },
      didOpen: () => {
        const $ = Swal.getHtmlContainer().querySelector.bind(Swal.getHtmlContainer());
        let currentPage = 1;
        const perPage = 5;

        const updateLogs = async () => {
          const excludes = ["add", "update", "delete", "recover"].filter(
            type => $("#excl-" + type)?.checked
          );
          const search = $("#search-logs")?.value || "";

          await fetchLogs({
            page: currentPage,
            per_page: perPage,
            excludes,
            search,
          });

          $("#log-table").innerHTML = renderTable(allLogs);
          renderPagination();
        };

        const renderPagination = () => {
          const container = $("#pagination-controls");
          const pages = [];
          const totalPages = pagination.last_page || 1;

          if (pagination.last_page <= 1) {
            container.innerHTML = '';
            return;
          }

          if (currentPage > 1) {
            pages.push(`<button class="btn btn-sm btn-secondary mx-1 page-btn" data-page="${currentPage - 1}">&lt;</button>`);
          }

          for (let i = 1; i <= totalPages; i++) {
            pages.push(`
              <button class="btn btn-sm mx-1 page-btn ${i === currentPage ? 'btn-primary' : 'btn-outline-secondary'}" data-page="${i}">
                ${i}
              </button>
            `);
          }

          if (currentPage < totalPages) {
            pages.push(`<button class="btn btn-sm btn-secondary mx-1 page-btn" data-page="${currentPage + 1}">&gt;</button>`);
          }

          container.innerHTML = pages.join("");

          container.querySelectorAll(".page-btn").forEach(btn => {
            btn.addEventListener("click", async () => {
              const page = parseInt(btn.getAttribute("data-page"));
              if (!isNaN(page) && page !== currentPage) {
                currentPage = page;
                await updateLogs();
              }
            });
          });
        };

        $("#apply-filter").addEventListener("click", async () => {
          currentPage = 1;
          await updateLogs();
        });

        $("#search-logs").addEventListener("input", debounce(async () => {
          currentPage = 1;
          await updateLogs();
        }, 500));

        updateLogs();
      },
    });
  };


  // onclick for recover
  document.addEventListener("click", function (e) {
    if (e.target && e.target.classList.contains("recover-btn")) {
      const id = e.target.getAttribute("data-maker-id");
      handleRecoverMaker(id);
    }
  });

  const confirmUnsavedChanges = () => {
    if (Object.keys(tempEdits).length > 0) {
      return window.confirm(
        "You have unsaved changes. Are you sure you want to switch?"
      );
    }
    return true; // No unsaved changes, safe to proceed
  };
  const filteredUsers = allUsers.filter((user, index) => {
    const matchesType =
      user.type === filterType || user.id === "" || tempEdits[index];
    const matchesSearch = user.name.toLowerCase().includes(searchQuery);
    return matchesType && matchesSearch;
  });

  const startIndex = (pagination.current_page - 1) * pagination.per_page;
  const endIndex = startIndex + pagination.per_page;
  const paginatedUsers = filteredUsers.slice(startIndex, endIndex);

  return (
    <div className="container py-4">
      <div className="py-12">
        <h2 className="fw-bold mb-3">TSD Settings</h2>
        <div className="toggle-button-group d-flex justify-content-center gap-3 mb-3">
          <button
            className={`toggle-btn px-4 py-2 ${
              filterType === "S" ? "active-toggle" : ""
            }`}
            onClick={() => {
              if (!confirmUnsavedChanges()) return;
              setFilterType("S");
              fetchTsdSettings("S");
              setTempEdits({});
            }}
          >
            <i className="bi bi-scissors me-2"></i> Sample Maker
          </button>

          <button
            className={`toggle-btn px-4 py-2 ${
              filterType === "P" ? "active-toggle" : ""
            }`}
            onClick={() => {
              if (!confirmUnsavedChanges()) return;
              setFilterType("P");
              fetchTsdSettings("P");
              setTempEdits({});
            }}
          >
            <i className="bi bi-rulers me-2"></i> Pattern Maker
          </button>
        </div>

        <div className="d-flex justify-content-end gap-2 tsd_btn_con mb-3">
          <input
            type="text"
            className="form-control search_maker"
            placeholder="Search user..."
            onChange={(e) => debouncedSetSearchQuery(e.target.value)}
          />
          <button
            className="add_sm btn btn-outline-primary d-flex align-items-center gap-2 px-3 py-1 rounded-3 shadow-sm"
            title="Add Sample/Pattern Maker"
            onClick={addNewUserLocal}
          >
            <FontAwesomeIcon icon={faPlus} />
           Maker
          </button>
          <div className="dropdown">
            <button
              className="tsd_dropdown btn btn-outline-secondary d-flex align-items-center gap-2 px-3 py-1 rounded-3 shadow-sm" title="Settings"
              type="button"
              id="gearDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{
                minWidth: "30px",
                height: "38px",
              }}
            >
              <FontAwesomeIcon icon={faGear} />
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3 mt-2"
              aria-labelledby="gearDropdown"
            >
              <li>
                <button
                  className="dropdown-item py-2 px-3"
                  onClick={handleLineNumber}
                >
                  <FontAwesomeIcon icon={faPenToSquare} /> Line No.
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item py-2 px-3"
                  onClick={handleCompany}
                >
                  <FontAwesomeIcon icon={faPenToSquare} /> Company
                </button>
              </li>
            </ul>
          </div>
                      <button
                className="tsd_logs btn btn-outline-primary d-flex align-items-center gap-2 px-3 py-1 rounded-3 shadow-sm" title="Logs"
                onClick={handleTsdLogs}
                >
            <FontAwesomeIcon icon={faClockRotateLeft} />
          </button>
        </div>
      </div>
      {loading ? (
        <div className="text-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h6>Loading..</h6>
        </div>
      ) : (
        <div className="list-group shadow-sm">
          <div className="list-group-item bg-light d-flex fw-bold">
            <div className="col-1">ID</div>
            <div className="col-3">Name</div>
            <div className="col-2">Company</div>
            <div className="col-1">Is Line Leader?</div>
            <div className="col-1">Is Assistant?</div>
            <div className="col-1">Line No.</div>
            <div className="col-2 text-center">Type</div>
            <div className="col-1 text-center">Actions</div>
          </div>

          {users
            .filter((user, index) => {
              const matchesType =
                user.type === filterType || user.id === "" || tempEdits[index];
              const matchesSearch = user.name
                .toLowerCase()
                .includes(searchQuery);
              return matchesType && matchesSearch;
            })
            .map((user, index) => (
              <div
                key={user.id}
                className={`list-group-item d-flex align-items-center ${
                  user.id === ""
                    ? "new-user-row bg-info bg-opacity-10 border border-info"
                    : ""
                }`}
              >
                <div className="col-1">{user.id}</div>
                <div className="col-3">
                  <input
                    className={`sm_input ${tempEdits[index]?.name ? "border border-danger" : ""}`}
                    type="text"
                    value={user.name}
                    onChange={(e) =>
                      handleInputChange(index, "name", e.target.value)
                    }
                  />
                </div>
                <div className="col-2">
                  <select
                    className={`form-select form-select-sm lineno_select ${tempEdits[index]?.company ? "border border-danger" : ""}`}
                    value={user.company || ""}
                    onChange={(e) =>
                      handleInputChange(index, "company", e.target.value)
                    }
                  >
                    <option value="" disabled>
                      Select Company
                    </option>
                    {companies.map((comp, i) => (
                      <option key={i} value={comp}>
                        {comp}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-1">
                  <div className="form-check form-switch form-switch-lg">
                    <input
                      className={`form-check-input toggle-lg`}
                      type="checkbox"
                      checked={user.lineLeader}
                      onChange={() =>
                        handleToggleExclusive(index, "lineLeader")
                      }
                    />
                  </div>
                </div>
                <div className="col-1">
                  <div className="form-check form-switch form-switch-lg">
                    <input
                      className={`form-check-input toggle-lg`}
                      type="checkbox"
                      checked={user.assistant}
                      onChange={() =>
                        handleToggleExclusive(index, "lineAssistant")
                      }
                    />
                  </div>
                </div>
                <div className="col-1">
                  <select
                    className={`form-select form-select-sm lineno_select ${tempEdits[index]?.lineNumber ? "border border-danger" : ""}`}
                    value={user.lineNumber}
                    onChange={(e) =>
                      handleInputChange(index, "lineNumber", e.target.value)
                    }
                  >
                    <option value="">Line No.</option>
                    {lineNumberList.map((lineNum) => (
                      <option key={lineNum} value={lineNum}>
                        {lineNum}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-2">
                  <select
                    className={`form-select form-select-sm text-center type_select ${tempEdits[index]?.type ? "border border-danger" : ""}`}
                    value={user.type}
                    onChange={(e) =>
                      handleInputChange(index, "type", e.target.value)
                    }
                  >
                    <option value="" disabled>
                      {" "}
                      Select Type
                    </option>
                    <option value="S">Sample Maker</option>
                    <option value="P">Pattern Maker</option>
                  </select>
                </div>
                <div className="col-1 text-end">
                  <button className="btn btn-sm btn-danger me-2"  onClick={() => handleDeleteUser(user.id)}>
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                  <button
                    className="btn btn-sm btn-success"
                    onClick={() => handleSaveUser(user)}
                  >
                    <FontAwesomeIcon icon={faFloppyDisk} />
                  </button>
                </div>
              </div>
            ))}
        </div>
      )}
      {pagination.last_page > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <nav>
            <ul className="pagination">
              <li
                className={`page-item ${
                  pagination.current_page === 1 ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() =>
                    fetchTsdSettings(
                      filterType,
                      false,
                      pagination.current_page - 1
                    )
                  }
                >
                  Previous
                </button>
              </li>

              {[...Array(pagination.last_page)].map((_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    pagination.current_page === i + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => fetchTsdSettings(filterType, false, i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}

              <li
                className={`page-item ${
                  pagination.current_page === pagination.last_page
                    ? "disabled"
                    : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() =>
                    fetchTsdSettings(
                      filterType,
                      false,
                      pagination.current_page + 1
                    )
                  }
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}{" "}
      {/*end pagination*/}
    </div>
  );
};

export default TsdSettings;
